import { FunctionComponent } from 'react';
import { BarLoader } from 'react-spinners';

export interface LoaderProps {
  isLoading: boolean;
}

const Loader: FunctionComponent<LoaderProps> = ({ isLoading = false }) => {
  return <BarLoader color="#2A6FDB" loading={isLoading} height={5} width="100%" css="display: block;" />;
};

export default Loader;
